import { request } from "@/interface/helper";

const str = "staff";

export const staff = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/user/list" }),
    add: data => request({ data, method: "post", url: "/user/add" }),
    detail: data => request({ data, method: "post", url: "/user/detail" }),
    edit: data => request({ data, method: "post", url: "/user/modify" })
  }
};
